import { get } from './commonFetch';

// ---- Define Types ---- //
export interface GeoLocation {
  latitude: string;
  longitude: string;
}

export interface Airport {
  airportCode: string;
  geoLocation: GeoLocation;
}

export interface Passenger {
  firstName: string;
  lastName: string;
}

export interface Trip {
  processedFlightHistoryId: number;
  tripId: string;
  recordLocator: string;
  groupName: string;
  passengers: Passenger[];
  assigneeUserNamesById: Record<string, string>;
  isCurrentFlightIssue: boolean;
  currentFlightIssueType?: string;
  isFutureFlightIssue: boolean;
}

export interface FlightData {
  flightNumber: string;
  codeShares: string;
  departureAirport: Airport;
  arrivalAirport: Airport;
  utcDepartureTime: string;
  utcArrivalTime: string;
  isCurrentFlightIssue: boolean;
  isFutureFlightIssue: boolean;
  trips: Trip[];
}

// ---- API Function ---- //
export async function fetchActiveFlights(queryParams: Record<string, any> = {}): Promise<FlightData[]> {
  const uri = "/api/travelermap/flights";
  return await get<FlightData[]>(uri);
}

export async function fetchActiveAirports(queryParams: Record<string, any> = {}): Promise<FlightData[]> {
  const uri = "/api/travelermap/airports";
  return await get<FlightData[]>(uri);
}